import { useQueryParams } from '@terminal/hooks/use-query-params/useQueryParams';
import { EMAIL_TRACKING_PARAM_KEYS } from '@terminal/routes/query-params';
import { POSTHOG_TRACKING_SOURCES } from '@terminal/services/tracking/posthog/constants';
import { useEffect, useRef } from 'react';

interface UseTrackEmailDrawerOpenOptions {
  isDrawerOpen: boolean;
  utmSource?: string | null;
  trackingKey?: string;
  onTrackEmailOpen: () => void;
}

export const useTrackEmailDrawerOpen = ({
  isDrawerOpen,
  utmSource,
  trackingKey,
  onTrackEmailOpen,
}: UseTrackEmailDrawerOpenOptions) => {
  const { deleteQueryParam } = useQueryParams();
  const trackedEmailOpenKeysRef = useRef<Set<string>>(new Set());

  useEffect(() => {
    if (!isDrawerOpen || !trackingKey) {
      trackedEmailOpenKeysRef.current.clear();
      return;
    }

    if (
      utmSource !== POSTHOG_TRACKING_SOURCES.EMAIL ||
      trackedEmailOpenKeysRef.current.has(trackingKey)
    ) {
      return;
    }

    trackedEmailOpenKeysRef.current.add(trackingKey);
    onTrackEmailOpen();
    deleteQueryParam([...EMAIL_TRACKING_PARAM_KEYS], { replace: true });
  }, [
    deleteQueryParam,
    isDrawerOpen,
    onTrackEmailOpen,
    trackingKey,
    utmSource,
  ]);
};
